
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Spinner from '../../common/client/components/Spinner';

const ProjectBussy = (props) => {
    return (
        <Stack horizontal verticalFill >
            <Stack.Item grow align="center">
                <Spinner
                    size={60}
                    width={15}
                    labelPosition="right"
                    labelStyle={{
                        fontSize: 28
                    }}
                    title={props.title}
                />
            </Stack.Item>
        </Stack>
    );
}

export default ProjectBussy;
